var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, forwardRef, } from "react";
import { Controller, } from "react-hook-form";
import { InputAdornment, Box } from "@mui/material";
import { Text } from "../../elements/Text";
import { Container, Input, FeedBackMessage, Label, PasswordRulesContainer, IconImage, ButtonStyled, } from "./styles";
import BulletIconImage from "../../../../images/icon-bullet.svg";
import CheckStrokeIconImage from "../../../../images/icon-check-stroke.svg";
import CloseIconImage from "../../../../images/icon-close.svg";
function InputBaseWithoutRef(_a, ref) {
    var name = _a.name, label = _a.label, errorText = _a.errorText, control = _a.control, defaultValues = _a.defaultValues, validations = _a.validations, rest = __rest(_a, ["name", "label", "errorText", "control", "defaultValues", "validations"]);
    var _b = __read(useState(false), 2), showPassword = _b[0], setShowPassword = _b[1];
    var handleClickShowPassword = function (event) {
        event.preventDefault();
        setShowPassword(function (prevState) { return !prevState; });
    };
    var handleMouseDownPassword = function (event) {
        event.preventDefault();
    };
    return (_jsxs(Container, { children: [label && _jsx(Label, __assign({ htmlFor: name }, { children: label })), _jsx(Controller, { name: name, control: control, defaultValue: defaultValues, render: function (_a) {
                    var _b = _a.field, onChange = _b.onChange, onBlur = _b.onBlur, value = _b.value;
                    return (_jsx(Input, __assign({}, rest, { inputRef: ref, fullWidth: true, error: !!errorText, onBlur: onBlur, onChange: onChange, value: value || "", type: showPassword ? "text" : "password", endAdornment: _jsx(InputAdornment, __assign({ position: "end" }, { children: _jsx(ButtonStyled, __assign({ tabIndex: -1, onClick: handleClickShowPassword, onMouseDown: handleMouseDownPassword }, { children: _jsx(Text, __assign({ textStyle: "button3", color: "tangerine" }, { children: showPassword ? "ocultar" : "exibir" })) })) })) })));
                } }), validations ? (_jsx(PasswordRulesContainer, { children: validations.map(function (error, idx) { return (_jsxs(Box, __assign({ display: "flex", alignItems: "center" }, { children: [_jsx(IconImage, { src: error.status === "invalid"
                                ? CloseIconImage
                                : error.status === "valid"
                                    ? CheckStrokeIconImage
                                    : BulletIconImage, alt: error.text }), _jsx(Text, __assign({ textStyle: "body3", color: error.status === "invalid"
                                ? "blood"
                                : error.status === "valid"
                                    ? "forest"
                                    : "smoke" }, { children: error.text }))] }), idx)); }) })) : (!!errorText && _jsx(FeedBackMessage, { children: errorText }))] }));
}
export var InputBaseStrongPassword = forwardRef(InputBaseWithoutRef);
